var ImageSliderGraphic      = require("./ImageSliderGraphic"),
    Layout                  = require("./GraphicContainerLayout"),
    RevolutionSliderGraphic = require("./RevolutionSliderGraphic"),
    VideoGraphic            = require("./VideoGraphic"),
    frameThrottle           = require("enyo-perf/utils").frameThrottle,
    get                     = require("object-path").get,
    kind                    = require("enyo/kind");

require("./GraphicContainer.less");

module.exports = kind(/** @lends app.ui.HeaderGraphic.GraphicContainer.prototype */ {

    /**
     * @private
     */
    name: "app.ui.HeaderGraphic.GraphicContainer",

    /**
     * @private
     */
    classes: "app-ui-header-graphic-graphic-container",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * Sets layout height and layout overflow. Can be used by other components
     * to align content on  top of the graphic.
     *
     * @type {Object}
     * @readonly
     * @public
     */
    layoutMetrics: null,

    /**
     * The width of the container in pixels.
     *
     * @name layoutMetrics.containerWidth
     * @type {number}
     * @readonly
     * @public
     */

    /**
     * The height of the container in pixels.
     *
     * @name layoutMetrics.containerHeight
     * @type {number}
     * @readonly
     * @public
     */

    /**
     * The width of the graphic in pixels.
     *
     * @name layoutMetrics.graphicWidth
     * @type {number}
     * @readonly
     * @public
     */

    /**
     * The height of the graphic in pixels.
     *
     * @name layoutMetrics.graphicHeight
     * @type {number}
     * @readonly
     * @public
     */

    /**
     * The amount of pixels by which the graphic breaks out of the container at
     * the bottom.
     *
     * @name layoutMetrics.graphicOverflow
     * @type {number}
     * @readonly
     * @public
     */

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:    "client",
        classes: "app-ui-header-graphic-graphic-container__client"
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.graphic.state"
    }, {
        from: ".layoutMetrics",
        to:   ".$.graphic.layoutMetrics"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.layoutMetrics = {
                containerWidth:  0,
                containerHeight: 0,
                graphicWidth:    0,
                graphicHeight:   0,
                graphicOverflow: 0
            };
            this.update        = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var GraphicKind = this.resolveGraphicKind(),
            $graphic    = this.$.graphic;

        // We need a new graphic
        if (!GraphicKind || !($graphic instanceof GraphicKind)) {
            $graphic && $graphic.destroy();
            $graphic = null;
        }

        if (GraphicKind && !$graphic) {
            $graphic       = this.createComponent({
                name:    "graphic",
                kind:    GraphicKind,
                classes: "app-ui-header-graphic-graphic-container__graphic"
            });
            this.hasNode() && $graphic.render();
            this.resize();
        }
    },

    /**
     * Resolves a variety of slider-related properties:
     *  - Which kind of slider, if any, should be shown.
     *  - Whether we should show slider buttons.
     *  - Whether we should show a cover
     *
     * @return  {?enyo.Control}  The kind if resolved, `null` otherwise.
     * @private
     */
    resolveGraphicKind: function() {
        var state     = this.state || {},
            mediaItem = get(state, "data", null);

        // No mediaItem
        if (!mediaItem) {
            return null;
        }

        // Revolution Slider
        if (get(mediaItem, "header_type", null) === "revolution_slider"
            && get(mediaItem, "revolution_slider_url", null)) {
            return RevolutionSliderGraphic;
        }

        // Video
        if (get(mediaItem, "header_type", null) === "preview_video"
            && get(mediaItem, "preview_url", null)) {
            return VideoGraphic;
        }

        // Image Slider
        if (get(mediaItem, "header_type", null) === "image_slider"
            && get(mediaItem, "meta.slides.length", 0) >= 1) {
            return ImageSliderGraphic;
        }

        // No slider
        return null;
    },

    /**
     * Resolves the layout style.
     *
     * @return  {string}  The layout style.
     * @private
     */
    resolveLayoutStyle: function() {
        var state     = this.state || {},
            mediaItem = get(state, "data", null),
            $graphic  = this.$.graphic;

        // Video overflows by default
        if ($graphic instanceof VideoGraphic
            && get(mediaItem, "header_overflow", true)) {
            return "overflow";
        }

        // Other sliders need explicit flag
        else {
            return get(mediaItem, "header_overflow", false) ? "overflow" : "classic";
        }
    }

});
